(function () {
  // Only run on product pages that have an add-to-cart form
  const hasProductForm = document.querySelector('form[action*="/cart/add"]');
  if (!hasProductForm) return;

  // Find the real product form buttons (can still exist even if visually hidden with CSS)
  const mainButtons = document.querySelector(".product-form__buttons");
  if (!mainButtons) return;

  // Try to grab the variant picker
const productHasRealVariants =
  document.querySelector('form[action*="/cart/add"] .product-variant-id') &&
  (
    document.querySelector('.tp-sticky-variant-source variant-selects select option[value="Default Title"]') === null ||
    document.querySelectorAll('.tp-sticky-variant-source variant-selects select').length > 1
  );

const mainVariantPicker = productHasRealVariants
  ? (
      document.querySelector(".tp-sticky-variant-source variant-selects") ||
      document.querySelector(".tp-sticky-variant-source .product-form__input--dropdown") ||
      document.querySelector(".tp-sticky-variant-source .product-form__input--pill") ||
      document.querySelector(".tp-sticky-variant-source .product-form__input--swatch") ||
      document.querySelector("variant-selects") ||
      document.querySelector(".product-form__input--dropdown") ||
      document.querySelector(".product-form__input--pill") ||
      document.querySelector(".product-form__input--swatch")
    )
  : null;

  // Prevent duplicate mount
  if (document.getElementById("tp-sticky-atc")) return;

  const sticky = document.createElement("div");
  sticky.id = "tp-sticky-atc";
  sticky.style.position = "fixed";
  sticky.style.left = "0";
  sticky.style.right = "0";
  sticky.style.bottom = "0";
  sticky.style.zIndex = "99999";
  sticky.style.transform = "translateY(6px)";
  sticky.style.background = "#fff";
  sticky.style.padding = "10px 12px calc(10px + env(safe-area-inset-bottom))";
  sticky.style.borderTop = "0";
  sticky.style.boxShadow = "0 -6px 18px rgba(0,0,0,0.10)";

  const inner = document.createElement("div");
  inner.style.display = "grid";
  inner.style.gap = "8px";
  inner.style.maxWidth = "720px";
  inner.style.margin = "0 auto";
  inner.style.gridTemplateColumns = "1fr";
  inner.style.gridAutoFlow = "row";

  const DESKTOP_BREAKPOINT = 990;

  function controlHeight() {
    return window.innerWidth >= DESKTOP_BREAKPOINT ? 44 : 40;
  }

  function applyDesktopLayout() {
    const isDesktop = window.innerWidth >= DESKTOP_BREAKPOINT;
    if (isDesktop) {
      inner.style.gridTemplateColumns = "1fr 1fr";
      inner.style.alignItems = "stretch";
    } else {
      inner.style.gridTemplateColumns = "1fr";
      inner.style.alignItems = "stretch";
    }
  }

  applyDesktopLayout();
  window.addEventListener("resize", applyDesktopLayout);

  // ========= Variant picker clone =========
  let variantWrapper = null;

  if (mainVariantPicker) {
    const variantClone = mainVariantPicker.cloneNode(true);

    variantWrapper = document.createElement("div");
    variantWrapper.id = "StickyVariantPicker";
    variantWrapper.className = "sticky-variant tp-sticky-variant-wrapper";
    variantWrapper.style.display = "flex";
    variantWrapper.style.alignItems = "stretch";
    variantWrapper.style.margin = "0";
    variantWrapper.style.padding = "0";
    variantWrapper.style.lineHeight = "1";
    variantWrapper.style.opacity = "1";
    variantWrapper.style.transform = "none";
    variantWrapper.style.pointerEvents = "auto";
    variantWrapper.style.transition = "none";

    // Remove duplicate ids / for attributes inside clone
    variantClone.removeAttribute("id");
    variantClone.querySelectorAll("[id]").forEach((el) => el.removeAttribute("id"));
    variantClone.querySelectorAll("label[for]").forEach((el) => el.removeAttribute("for"));

    // Hide labels in sticky version
    variantClone.querySelectorAll(".form__label").forEach((lbl) => {
      lbl.style.display = "none";
    });

    variantClone.style.margin = "0";
    variantClone.style.padding = "0";
    variantClone.style.width = "100%";
    variantClone.style.display = "block";

    variantClone.querySelectorAll(".select, .product-form__input").forEach((wrap) => {
      wrap.style.margin = "0";
      wrap.style.padding = "0";
      wrap.style.boxShadow = "none";
      wrap.style.border = "0";
      wrap.style.background = "transparent";
      wrap.style.width = "100%";
      wrap.style.height = controlHeight() + "px";
      wrap.style.display = "flex";
      wrap.style.alignItems = "stretch";
    });

    variantClone.querySelectorAll("select").forEach((sel) => {
      sel.style.background = "#fff";
      sel.style.color = "#000";
      sel.style.border = "1px solid #000";
      sel.style.borderRadius = "0";
      sel.style.boxShadow = "none";
      sel.style.outline = "none";
      sel.style.webkitAppearance = "none";
      sel.style.appearance = "none";
      sel.style.height = controlHeight() + "px";
      sel.style.minHeight = controlHeight() + "px";
      sel.style.lineHeight = controlHeight() + "px";
      sel.style.margin = "0";
      sel.style.display = "block";
      sel.style.width = "100%";
      sel.style.fontSize = "15px";
      sel.style.padding = "0 14px";
    });

    variantClone.querySelectorAll('input[type="radio"] + label').forEach((pill) => {
      pill.style.background = "#fff";
      pill.style.color = "#000";
      pill.style.border = "1px solid #000";
      pill.style.borderRadius = "0";
      pill.style.boxShadow = "none";
      pill.style.margin = "0";
      pill.style.lineHeight = "1";
      pill.style.padding = "8px 10px";
      pill.style.fontSize = "14px";
    });

    variantWrapper.appendChild(variantClone);
    inner.appendChild(variantWrapper);
  }

  // ========= Button clone =========
  const buttonsClone = mainButtons.cloneNode(true);
  buttonsClone.style.margin = "0";
  buttonsClone.style.padding = "0";
  buttonsClone.style.display = "flex";
  buttonsClone.style.alignItems = "stretch";

  const stickySubmit = buttonsClone.querySelector('button[type="submit"]');
  if (stickySubmit) {
    stickySubmit.style.background = "#000";
    stickySubmit.style.color = "#fff";
    stickySubmit.style.border = "1px solid #000";
    stickySubmit.style.borderRadius = "0";
    stickySubmit.style.boxShadow = "none";
    stickySubmit.style.minHeight = "44px";
    stickySubmit.style.height = "44px";
    stickySubmit.style.lineHeight = "44px";
    stickySubmit.style.padding = "0 18px";
    stickySubmit.style.fontSize = "15px";
    stickySubmit.style.letterSpacing = "0.06rem";
    stickySubmit.style.margin = "0";
    stickySubmit.style.width = "100%";
  }

  inner.appendChild(buttonsClone);
  sticky.appendChild(inner);
  document.body.appendChild(sticky);

  // Remove Dawn pseudo borders/shadows inside sticky controls
  const styleTag = document.createElement("style");
  styleTag.textContent = `
    #tp-sticky-atc .tp-sticky-variant-wrapper .select:before,
    #tp-sticky-atc .tp-sticky-variant-wrapper .select:after,
    #tp-sticky-atc .tp-sticky-variant-wrapper .field:before,
    #tp-sticky-atc .tp-sticky-variant-wrapper .field:after,
    #tp-sticky-atc .tp-sticky-variant-wrapper .product-form__input:before,
    #tp-sticky-atc .tp-sticky-variant-wrapper .product-form__input:after {
      content: none !important;
      box-shadow: none !important;
      border: 0 !important;
    }
  `;
  document.head.appendChild(styleTag);

  function setBodyPadding() {
    const h = sticky.getBoundingClientRect().height || 120;
    document.body.style.paddingBottom = Math.ceil(h + 12) + "px";
  }

  setBodyPadding();
  window.addEventListener("resize", setBodyPadding);

  // Sync button state/text
  const mainSubmit = mainButtons.querySelector('button[type="submit"]');

  function sync() {
    if (!mainSubmit || !stickySubmit) return;

    stickySubmit.disabled = mainSubmit.disabled;

    const mainLabel = mainSubmit.querySelector("span");
    const stickyLabel = stickySubmit.querySelector("span");
    if (mainLabel && stickyLabel) {
      stickyLabel.textContent = mainLabel.textContent;
    }
  }

  sync();
  document.addEventListener("change", () => {
    setTimeout(sync, 50);
    setTimeout(sync, 250);
  });

  // Sticky click triggers real add-to-cart
  if (stickySubmit && mainSubmit) {
    stickySubmit.addEventListener("click", function (e) {
      e.preventDefault();
      mainSubmit.click();
    });
  }

  // Bridge sticky variant changes back to the real picker
  function bridgeVariantChanges() {
    if (!variantWrapper) return;

    variantWrapper.querySelectorAll("select").forEach((stickySel) => {
      stickySel.addEventListener("change", () => {
        const name = stickySel.getAttribute("name");
        if (!name) return;

        const realSel = document.querySelector(`select[name="${CSS.escape(name)}"]`);
        if (!realSel) return;

        realSel.value = stickySel.value;
        realSel.dispatchEvent(new Event("change", { bubbles: true }));
        setTimeout(sync, 50);
      });
    });

    variantWrapper.querySelectorAll('input[type="radio"]').forEach((stickyRadio) => {
      stickyRadio.addEventListener("change", () => {
        if (!stickyRadio.name) return;

        const realRadio = document.querySelector(
          `input[type="radio"][name="${CSS.escape(stickyRadio.name)}"][value="${CSS.escape(stickyRadio.value)}"]`
        );
        if (!realRadio) return;

        realRadio.checked = true;
        realRadio.dispatchEvent(new Event("change", { bubbles: true }));
        setTimeout(sync, 50);
      });
    });
  }

  bridgeVariantChanges();

  console.log("[tp-sticky-atc] mounted");
})();